var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('hook',{attrs:{"zone":"top"}},[_c('Footer-Top',{staticClass:"py-6",attrs:{"data":_vm.dataTop}})],1),_c('Footer-Bottom',{attrs:{"data":_vm.dataBottom}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }